(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("mobx"), require("mobxReact"), require("sbJsExtends"), require("ReactDOM"));
	else if(typeof define === 'function' && define.amd)
		define("sbCommonLib", ["React", "mobx", "mobxReact", "sbJsExtends", "ReactDOM"], factory);
	else if(typeof exports === 'object')
		exports["sbCommonLib"] = factory(require("React"), require("mobx"), require("mobxReact"), require("sbJsExtends"), require("ReactDOM"));
	else
		root["sbCommonLib"] = factory(root["React"], root["mobx"], root["mobxReact"], root["sbJsExtends"], root["ReactDOM"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__, __WEBPACK_EXTERNAL_MODULE__12__, __WEBPACK_EXTERNAL_MODULE__13__) {
return 